import { render, staticRenderFns } from "./InviteRoleEdit.vue?vue&type=template&id=fb1a3908"
import script from "./InviteRoleEdit.vue?vue&type=script&lang=js"
export * from "./InviteRoleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports